<template>
    <kimsa-grid-table :headers="headers" :items="coaches" :loading="loading" item-key="id" disable-sort
        :skeleton-count="perPage" :no-data-text="noDataText">
        <template v-slot:item.name="{ item }">
            <div class="coach-main">
                <div v-if="item.avatar" class="coach-avatar" :style="{ backgroundImage: `url('${item.avatar}')` }" />
                <div v-else class="coach-avatar-initials" :style="item.avatarGradient">{{ item.initials }}</div>
                <truncated-text class="coach-name" :text="item.name" />
            </div>
        </template>
        <template v-slot:item.activeStudents="{ item }">
            <span class="students-count">{{ item.activeStudents }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
            <div class="row-actions">
                <button-tooltip top :tooltip="$t('tooltips.unlink_coach')">
                    <template v-slot:activator="{ on, attrs }">
                        <button type="button" class="icon-btn unlink" v-bind="attrs" v-on="on"
                            @click="$emit('click:unlink', item)">
                            <v-icon size="15">mdi-link-variant-off</v-icon>
                        </button>
                    </template>
                </button-tooltip>
                <button-tooltip top :tooltip="$t('tooltips.see_profile')">
                    <template v-slot:activator="{ on, attrs }">
                        <button type="button" class="icon-btn" v-bind="attrs" v-on="on"
                            @click="$emit('click:profile', item)">
                            <v-icon size="15">mdi-magnify</v-icon>
                        </button>
                    </template>
                </button-tooltip>
            </div>
        </template>
        <template v-slot:footer>
            <slot name="footer" />
        </template>
    </kimsa-grid-table>
</template>

<script>
import KimsaGridTable from "@/components/common/KimsaGridTable";
import TruncatedText from "@/components/common/TruncatedText";
import ButtonTooltip from "@/components/common/ButtonTooltip";

export default {
    name: "AdminCoachesTable",
    components: { KimsaGridTable, TruncatedText, ButtonTooltip },
    props: {
        coaches: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        perPage: {
            type: Number,
            default: 10,
        },
        noDataText: {
            type: String,
            default: '',
        },
    },
    computed: {
        headers(vm = this) {
            return [
                { text: vm.$t('common.name'), value: 'name', width: 'minmax(160px, 1fr)' },
                { text: vm.$t('common.quantity_students'), value: 'activeStudents', width: '140px' },
                { text: '', value: 'actions', width: '92px', align: 'end' },
            ]
        },
    },
}
</script>

<style scoped>
.coach-main {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.coach-avatar,
.coach-avatar-initials {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    flex-shrink: 0;
}

.coach-avatar {
    background-size: cover;
    background-position: center;
    background-color: var(--v-surface2-base);
}

.coach-avatar-initials {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
}

.coach-name {
    font-size: 13px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    min-width: 0;
}

.students-count {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
}

.row-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
}

.icon-btn {
    width: 26px;
    height: 26px;
    border-radius: 7px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--v-txtMuted-base);
    transition: background 0.15s, color 0.15s;
}

.icon-btn:hover {
    background: var(--v-surface2-base);
    color: var(--v-txtPrimary-base);
}

.icon-btn.unlink:hover {
    color: var(--v-error-base);
}
</style>
